import React from 'react';
import { observer } from 'mobx-react';
import { Col, Row } from 'antd';
import UpdateProfile from './component/ProfileUpdate';
import ChangePassword from './component/ChangePassword';

const Profile = observer(() => {
	return (
		<div className="mainPageWrap">
			<Row gutter={24}>
				<Col span={12}>
					<UpdateProfile />
				</Col>
				<Col span={12}>
					<ChangePassword />
				</Col>
			</Row>
		</div>
	);
});

export default Profile;
